import { render, staticRenderFns } from "./LoginFrom.vue?vue&type=template&id=1021560f&scoped=true"
import script from "./LoginFrom.vue?vue&type=script&lang=js"
export * from "./LoginFrom.vue?vue&type=script&lang=js"
import style0 from "./LoginFrom.vue?vue&type=style&index=0&id=1021560f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1021560f",
  null
  
)

export default component.exports